
import { searchEvent, searchFilterResetEvent, SearchTagEventData, searchTagEventUpdate } from "../search/search-events";

export default class SearchTagFilter {
    private filterContainer: HTMLElement;
    private allTags: HTMLElement[];
    constructor(containerId: string) {
        this.filterContainer = document.getElementById(containerId);
        this.allTags = Array.from(this.filterContainer.querySelectorAll('.search__tag'));
        this.AddEventListener();
    }

    AddEventListener() {
        this.allTags.forEach(tagBtn => {
            tagBtn.addEventListener('click', () => {
                this.allTags.forEach(item => item.classList.remove('active'))
                if (tagBtn.classList.contains('active')) {
                    return;
                }
                tagBtn.classList.add('active');
                if (!tagBtn.getAttribute('data-value')) {
                    searchEvent.emit(searchFilterResetEvent);
                } else {

                    this.UpdateSearchTag(tagBtn);
                }
            })
        })
    }
    UpdateSearchTag(selectedElement: HTMLElement): void {
        // Send an event to the listing widget
        const filterEventData: SearchTagEventData = {
            tag: selectedElement.getAttribute("data-value")
        };

        // Emit the event
        searchEvent.emit(searchTagEventUpdate, filterEventData);
    }
}
